// Achat rapide en ligne dans la carte produit (système de l'ancien site).
// Gère la sélection des puces (taille, couleur), résout la variante,
// grise les combinaisons épuisées ; l'envoi reste porté par le
// <product-form> de Dawn (tiroir panier, erreurs, état de chargement).
if (!customElements.get('kenza-card-buy')) {
  customElements.define(
    'kenza-card-buy',
    class KenzaCardBuy extends HTMLElement {
      connectedCallback() {
        try {
          this.variants = JSON.parse(this.querySelector('[data-kenza-variants]').textContent);
        } catch (e) {
          this.variants = [];
        }
        this.chips = [...this.querySelectorAll('.kenza-card-buy__chip')];
        this.input = this.querySelector('input.product-variant-id');
        this.submit = this.querySelector('button[type="submit"]');
        this.optionCount = new Set(this.chips.map((c) => c.dataset.opt)).size;
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('.kenza-card-buy__chip');
          if (!chip) return;
          this.chips
            .filter((c) => c.dataset.opt === chip.dataset.opt)
            .forEach((c) => {
              c.classList.toggle('is-selected', c === chip);
              c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
            });
          this.refresh();
        });
        this.refresh();
      }

      selectedOptions() {
        const opts = [];
        for (let i = 0; i < this.optionCount; i++) {
          const sel = this.chips.find((c) => c.dataset.opt === String(i) && c.classList.contains('is-selected'));
          opts.push(sel ? sel.dataset.value : null);
        }
        return opts;
      }

      refresh() {
        const selected = this.selectedOptions();
        // griser les valeurs sans combinaison disponible avec le reste de la sélection
        this.chips.forEach((chip) => {
          const idx = Number(chip.dataset.opt);
          const candidate = selected.slice();
          candidate[idx] = chip.dataset.value;
          const ok = this.variants.some(
            (v) => v.a && candidate.every((val, i) => val === null || v.o[i] === val)
          );
          chip.classList.toggle('is-unavailable', !ok);
        });
        // résoudre la variante exacte
        const exact = this.variants.find((v) => selected.every((val, i) => v.o[i] === val));
        const label = this.submit ? this.submit.querySelector('span') : null;
        if (exact) {
          this.input.value = exact.id;
          this.input.disabled = !exact.a;
          if (this.submit) this.submit.disabled = !exact.a;
          if (label) label.textContent = exact.a ? window.kenzaCardBuyStrings.add : window.kenzaCardBuyStrings.soldOut;
        } else {
          this.input.disabled = true;
          if (this.submit) this.submit.disabled = true;
          if (label) label.textContent = window.kenzaCardBuyStrings.unavailable;
        }
      }
    }
  );
}
